import React, { useContext, useMemo, useState } from 'react'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import {
  getOpThreshold,
  saveOpThreshold,
  deleteOpThreshold,
  getAuthorization,
  getCredentials,
} from '../api/pgads'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
} from 'core'
import { connect } from 'react-redux'
import { Button, DatePicker, Icon, InputNumber, message, Upload } from 'antd'
import {
  DatePickerContext,
  PNodeZoneContext,
  ErrorContext,
  SpinContext,
  JcTmpErrorContext,
} from 'context'

import MarginAnalysisUtilityUnitSelection from '../marginanalysis/MarginAnalysisUtilityUnitSelection'
import { Label } from '../core/screen-util'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { hasAccesPermits, isValidYearRange } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const title = 'Daily Op. Rsv. Threshold'

const OpThreshold = ({ envConfig, actionPermits, targetInfo }) => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const {
    unitIdEmktIdMap,
    emktIdUnitNameMap,
    // marginUnitsList,
    emktUnits,
  } = useContext(PNodeZoneContext)

  const [insertEvent, setInsertEvent] = useState(false)

  const hasImportPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OP_THRESHOLD_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/pjm/import-op-threshold-manual`,
    method: 'POST',
    data: {},
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const extraCriteriaAfterButton = () => {
    if (!hasImportPermission) return <div />
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          columnGap: '10px',
          border: '0px solid black',
          padding: '2px',
        }}
      >
        <Upload
          {...fileProps}
          beforeUpload={_ => setSpinning(true)}
          onChange={data => {
            setSpinning(false)
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')
              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setTmpError(data.file.response)
              //  if (data.file.response) {
              // message.success('File imported successfully')
              // }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            disabled={!hasImportPermission}
            type="primary"
            style={{ width: '100%' }}
          >
            <Icon type="upload" /> Import
          </Button>
        </Upload>
      </div>
    )
  }

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId).map(id => unitIdEmktIdMap[id]),
    startdate: selectedDateRangePicker[0],
    enddate: selectedDateRangePicker[1],
  })

  const extraUnitSelectionProps = _ => ({
    limitedUnits: emktUnits,
    units: emktUnits,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = OaDailyOpRsvThresholdHeaders.map(header =>
    header.ident === 'unitId' ||
    header.ident === 'unitid' ||
    header.ident === 'zone'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.zone] ||
            emktIdUnitNameMap[rowData.zone] ||
            rowData.zone ||
            rowData.zone,
        }
      : header
  )
  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }
  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns:
          '70px 300px 80px 150px 250px 100px 100px 100px 100px',
        columnGap: '10px',
      }}
    >
      <Label>Unit :</Label>

      <MarginAnalysisUtilityUnitSelection
        utility={insertData.utility || null}
        unit={insertData.unit || null}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            utility: value[0],
            unit: value[1],
            unitId: unitIdEmktIdMap[value[1]],
            zone: unitIdEmktIdMap[value[1]],
          })
        }}
        style={{ width: '100%' }}
      />

      <Label style={{ minWidth: '80px' }}>Transdate :</Label>
      <DatePicker
        style={{ minWidth: '120px' }}
        onChange={date =>
          setInsertData({
            ...insertData,
            transdate: date.format('YYYY-MM-DD'),
            transDate2: date,
            // transDate: date,
          })
        }
        value={insertData.transDate2}
        placeholder="Transdate"
        format="MM/DD/YYYY"
        allowClear={false}
      />
      <Label>Op. Rsv. Threshold ($/MW) :</Label>

      <InputNumber
        defaultValue={0}
        value={insertData.opRsvThreshold}
        onChange={value =>
          setInsertData({ ...insertData, opRsvThreshold: value })
        }
      />
      <Button type="primary" onClick={() => onAdd(true)}>
        Add
      </Button>
      <Button type="primary" onClick={() => onAdd(false)}>
        Add & Hide
      </Button>
      <Button type="danger" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      titleProps={{ width: '300px' }}
      screenCriteria={screenCriteria}
      extraUnitSelectionProps={extraUnitSelectionProps}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withCriteria={withCriteria}
      withUnitSelection
      isAdminScreen={false}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getOpThreshold}
      deleteTask={deleteOpThreshold}
      saveTask={saveOpThreshold}
      altBy={d => d.transdate}
      autoRetrieve={false}
      sortOptions={OaDailyOpRsvThresholdHeaders}
      // totalWidth={800}
      widthOffset={200}
      heightOffset={270}
      insertCompHeight={60}
      onInsertEvent={isInsert => setInsertEvent(isInsert)}
      insertComp={insertEvent && insertComp}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(OpThreshold)

const OaDailyOpRsvThresholdHeaders = [
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    sortOptions: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'zone',
    display: 'Unit ID',
    isKey: true,
    sortOptions: 'asc',
    width: 350,
  }),
  numCol({
    ident: 'opRsvThreshold',
    display: 'Op. Rsv. Threshold ($/MW)',
    isFiltered: true,
    sortOptions: 'asc',
    width: 250,
    isKey: true,
  }),
  // strCol({ ident: 'deleted', display: 'Deleted', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]
